"use strict";
/*
  This file is part of web3x.

  web3x is free software: you can redistribute it and/or modify
  it under the terms of the GNU Lesser General Public License as published by
  the Free Software Foundation, either version 3 of the License, or
  (at your option) any later version.

  web3x is distributed in the hope that it will be useful,
  but WITHOUT ANY WARRANTY; without even the implied warranty of
  MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
  GNU Lesser General Public License for more details.

  You should have received a copy of the GNU Lesser General Public License
  along with web3x.  If not, see <http://www.gnu.org/licenses/>.
*/

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var personal_request_payloads_1 = require("./personal-request-payloads");

var Personal = /*#__PURE__*/function () {
  function Personal(provider) {
    _classCallCheck(this, Personal);

    this.provider = provider;
    this.request = new personal_request_payloads_1.PersonalRequestPayloads();
  }

  _createClass(Personal, [{
    key: "send",
    value: function () {
      var _send = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
        var method, params, format;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                method = _ref.method, params = _ref.params, format = _ref.format;
                _context.t0 = format;
                _context.next = 4;
                return this.provider.send(method, params);

              case 4:
                _context.t1 = _context.sent;
                return _context.abrupt("return", (0, _context.t0)(_context.t1));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "getAccounts",
    value: function () {
      var _getAccounts = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var payload;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                payload = this.request.getAccounts();
                _context2.next = 3;
                return this.send(payload);

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getAccounts() {
        return _getAccounts.apply(this, arguments);
      }

      return getAccounts;
    }()
  }, {
    key: "newAccount",
    value: function () {
      var _newAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(password) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                payload = this.request.newAccount(password);
                _context3.next = 3;
                return this.send(payload);

              case 3:
                return _context3.abrupt("return", _context3.sent);

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function newAccount(_x2) {
        return _newAccount.apply(this, arguments);
      }

      return newAccount;
    }()
  }, {
    key: "unlockAccount",
    value: function () {
      var _unlockAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(address, password, duration) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                payload = this.request.unlockAccount(address, password, duration);
                _context4.next = 3;
                return this.send(payload);

              case 3:
                return _context4.abrupt("return", _context4.sent);

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function unlockAccount(_x3, _x4, _x5) {
        return _unlockAccount.apply(this, arguments);
      }

      return unlockAccount;
    }()
  }, {
    key: "lockAccount",
    value: function () {
      var _lockAccount = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(address) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                payload = this.request.lockAccount(address);
                _context5.next = 3;
                return this.send(payload);

              case 3:
                return _context5.abrupt("return", _context5.sent);

              case 4:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function lockAccount(_x6) {
        return _lockAccount.apply(this, arguments);
      }

      return lockAccount;
    }()
  }, {
    key: "importRawKey",
    value: function () {
      var _importRawKey = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(privateKey, password) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                payload = this.request.importRawKey(privateKey, password);
                _context6.next = 3;
                return this.send(payload);

              case 3:
                return _context6.abrupt("return", _context6.sent);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function importRawKey(_x7, _x8) {
        return _importRawKey.apply(this, arguments);
      }

      return importRawKey;
    }()
  }, {
    key: "sendTransaction",
    value: function () {
      var _sendTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(tx, password) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                payload = this.request.sendTransaction(tx, password);
                _context7.next = 3;
                return this.send(payload);

              case 3:
                return _context7.abrupt("return", _context7.sent);

              case 4:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function sendTransaction(_x9, _x10) {
        return _sendTransaction.apply(this, arguments);
      }

      return sendTransaction;
    }()
  }, {
    key: "signTransaction",
    value: function () {
      var _signTransaction = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(tx, password) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                payload = this.request.signTransaction(tx, password);
                _context8.next = 3;
                return this.send(payload);

              case 3:
                return _context8.abrupt("return", _context8.sent);

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function signTransaction(_x11, _x12) {
        return _signTransaction.apply(this, arguments);
      }

      return signTransaction;
    }()
  }, {
    key: "sign",
    value: function () {
      var _sign = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(message, address, password) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                payload = this.request.sign(message, address, password);
                _context9.next = 3;
                return this.send(payload);

              case 3:
                return _context9.abrupt("return", _context9.sent);

              case 4:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function sign(_x13, _x14, _x15) {
        return _sign.apply(this, arguments);
      }

      return sign;
    }()
  }, {
    key: "ecRecover",
    value: function () {
      var _ecRecover = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(message, signedData) {
        var payload;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                payload = this.request.ecRecover(message, signedData);
                _context10.next = 3;
                return this.send(payload);

              case 3:
                return _context10.abrupt("return", _context10.sent);

              case 4:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function ecRecover(_x16, _x17) {
        return _ecRecover.apply(this, arguments);
      }

      return ecRecover;
    }()
  }]);

  return Personal;
}();

exports.Personal = Personal;